import type { FormatDateOptions } from 'react-intl';

import { type onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsConnectionSlice';
import { parseDate, sendMailNotification } from 'app/main/components/Utils';
import { DetailsEventsWrapper } from 'app/main/components/page-layouts';

const sendSaveNotification: onAfterSaveType = ({ intl, isAdd, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.leav_user_assigned_uid &&
			modifiedModel.leav_user_assigned_uid !== model.leav_user_modified_uid
		) {
			sendNotification({
				message: {
					createdBy: modifiedModel.leav_user_modified_uid,
					assignedTo: modifiedModel.leav_user_assigned_uid,
					title: 'Nuovo Permesso assegnato',
					body: `${model.user_modified_title} ti ha assegnato a "${model.leav_title}".`,
					url: `${window.location.origin}/leave/details/${model.leav_uid}`,
					icon: 'luggage',
					variant: 'info'
				}
			});
		}

		const data = { ...model, ...modifiedModel };

		const dateFormat: FormatDateOptions = {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit'
		};
		const dateFrom = intl.formatDate(parseDate(data.leav_d_from)?.toDate(), dateFormat);
		const dateTo = intl.formatDate(parseDate(data.leav_d_to)?.toDate(), dateFormat);

		if (isAdd && data.notification_mails?.length > 0) {
			sendMailNotification({
				data: {
					subject: `${import.meta.env.VITE_TITLE} - Richiesto permesso`,
					message: `L'utente ${data.user_created_title} ha richiesto il permesso "${data.leav_title}" dal ${dateFrom} al ${dateTo}.`,
					recipients: model.notification_mails
				}
			});
		}

		if (
			!!model.user_mail &&
			modifiedModel.leav_lvst_id !== model.leav_lvst_id &&
			[2, 4].includes(modifiedModel.leav_lvst_id)
		) {
			const typeString = data.leav_lvst_id === 2 ? 'accettato' : 'rifiutato';

			const mailData = {
				subject: `${import.meta.env.VITE_TITLE} - Permesso ${typeString}`,
				message: `Il permesso "${data.leav_title}" dal ${dateFrom} al ${dateTo} è stato ${typeString}.`,
				recipients: [model.user_mail]
			};

			sendMailNotification({ data: mailData });
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params.modifiedModel)([sendSaveNotification(params)]);

export default { onAfterSave };
